export function stringValidation(input: string) {
  const pattern = /^(?=.*[a-zA-Z])[a-zA-Z '-]*$|^$/;
  return pattern.test(input);
}
